import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {FormControl, FormGroup, FormsModule, Validators} from "@angular/forms";
import {VerifyOtpRequest} from "../../../models/auth.models";
import {AuthService} from "../../../services/auth.service";
import {DynamicDialogConfig, DynamicDialogRef} from "primeng/dynamicdialog";

@Component({
  selector: 'app-otp-dialog',
  templateUrl: './otp-dialog.component.html',
  styleUrls: ['./otp-dialog.component.css']
})
export class OtpDialogComponent implements OnInit {

  protected errorMessage?: string;
  protected otpForm: FormGroup;
  public newOtpDisabled : boolean = false;
  @Output() onVerifyOtp = new EventEmitter<any>();
  @Output() onNewOtpRequest = new EventEmitter<any>();

  constructor()
  {
    this.otpForm = new FormGroup({
      otp: new FormControl('', Validators.required)
    });
  }

  ngOnInit(): void {}

  protected async onSubmit() {
    const otp = this.otpForm.get('otp')?.value;
    this.onVerifyOtp.emit(otp);
  }

  protected async newOtpRequest(){
    this.onNewOtpRequest.emit(null);
    this.newOtpDisabled = true;
    setTimeout(() => {
      this.newOtpDisabled = false;
    }, 5000);
  }


}
